/**
 * @flow
 */

import React from 'react';
import { format, addMinutes, startOfDay } from 'date-fns';
import { useSelector } from 'react-redux';
import { Select } from '../../../../../components';

function ServiceDurationSelect({ meta: _meta, dispatch: _dispatch, ...props }) {
    const settings = useSelector(({ salon }) => salon.get('settings'));
    const step = settings ? settings.step : 30;

    const options = [];
    for (let i = step; i <= 360; i += step) {
        options.push({
            value: i,
            text: format(addMinutes(startOfDay(new Date()), i), 'HH:mm'),
        });
    }

    return <Select options={options} {...props} />;
}

export default ServiceDurationSelect;
